import moment from 'moment';
import 'moment-timezone';
import PopMessage from 'component/pop-msg/PopMessage';
import ReactDOM from 'react-dom';

// -- PASS moment to front
window.moment = moment;
//moment.tz.setDefault('Etc/GMT+8');

export const C_DTM_DATA  = 'YYYY-MM-DDTHH:mm:ss';
export const C_DTM_FULL  = 'YYYY-MM-DD HH:mm:ss';
export const C_DTM_LONG  = 'YYYY-MM-DD HH:mm';
export const C_DTM_SHORT = 'YYYY-MM-DD';

export const HistState = Object.freeze({
  Past: 0,
  Present: 1,
  Future: 2,
});

export const ActionType = Object.freeze({
  Start: 1,
  Change: 2,
  Suspend: 3,
  Terminate: 4,
  ChangeLicense: 5,
});

export const enterPressed = callback => (e => {
  if (e.key === 'Enter') callback();
});

export function rgbToHsl(r, g, b) {
  r /= 255;
  g /= 255;
  b /= 255;
  let max = Math.max(r, g, b), min = Math.min(r, g, b);
  let h, s, l = (max + min) / 2;

  if(max == min){
    h = s = 0; // achromatic
  }else{
    let d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch(max){
      case r: h = (g - b) / d + (g < b ? 6 : 0); break;
      case g: h = (b - r) / d + 2; break;
      case b: h = (r - g) / d + 4; break;
    }
    h /= 6;
  }
  return [h, s, l];
}

export function hslToRgb(h, s, l) {
  let r, g, b;

  if (s == 0){
    r = g = b = l; // achromatic
  } else {
    let hue2rgb = function hue2rgb(p, q, t){
      if(t < 0) t += 1;
      if(t > 1) t -= 1;
      if(t < 1/6) return p + (q - p) * 6 * t;
      if(t < 1/2) return q;
      if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
      return p;
    }

    let q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    let p = 2 * l - q;
    r = hue2rgb(p, q, h + 1/3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1/3);
  }

  return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
}

export function hexToRgb(hex)
{
  hex = hex.replace('#', '');
  return [
    parseInt(hex.substring(0,2), 16),
    parseInt(hex.substring(2,4), 16),
    parseInt(hex.substring(4,6), 16),
  ];
}

export function padZero(s, n)
{
  s = '0'.repeat(n) + String(s);
  return s.slice(s.length - n);
}

export function rearrange2d(ori)
{
  const R3 = ori.length % 3;
  const N3 = Math.ceil(ori.length/3);

  let [a,b,c] = [[],[],[]];
  switch (R3)
  {
    case 1:
      a = ori.slice(0, N3);
      b = ori.slice(N3, 2*N3-1);
      c = ori.slice(N3*2-1, ori.length);
      break;
    default:
      a = ori.slice(0, N3);
      b = ori.slice(N3, 2*N3);
      c = ori.slice(N3*2, ori.length);
      break;
  }

  let nwa = [];
  for (let i = 0; i < N3; i++)
  {
    nwa.push(a[i]);
    nwa.push(b[i]);
    nwa.push(c[i]);
  }

  nwa = nwa.filter(x => 'undefined' != typeof x);
  return nwa;
}

moment.defineLocale('zh-HK', {
  months: ['一月','二月','三月','四月','五月','六月','七月','八月','九月','十月','十一月','十二月'],
  monthsShort: ['一月','二月','三月','四月','五月','六月','七月','八月','九月','十月','十一月','十二月'],
  weekdays: ['星期日','星期一','星期二','星期三','星期四','星期五','星期六'],
  weekdaysShort: ['日','一','二','三','四','五','六'],
  relativeTime : {
    future : '%s 之內',
    past : '%s 前',
    s : '秒',
    m : '1 分鐘',
    mm : '%d 分鐘',
    h : '1 小時',
    hh : '%d 小時',
    d : '1 日',
    dd : '%d 日',
    M : '1 月',
    MM : '%d 月',
    y : '1 年',
    yy : '%d 年'
},
});
// https://programmer.group/moment.js-display-chinese.html

// global singleton variable
let dictLoc = null;

class Utility
{
  toJson(obj)
  {
    return JSON.stringify(obj, (key,value) => {
      if ('Date' === value?.constructor.name) {
        return moment(value).tz('Etc/GMT+8').format();
      }
      return value;
    });
  }

  hasValue(v)
  {
    if ('undefined' === typeof v) return false;
    if (null == v) return false;
    return true;
  }
  getRoleName(role)
  {
    switch (role)
    {
      case 'SYSTEM': return '系統';
      case 'ADMIN': return '管理員';
      case 'OPERATOR': return '操作員';
      case 'WORKER': return '判工';
      case 'CUSTOMER': return '顧客';
      case 'VIEWER_SU': return '老闆';
      case 'VIEWER_DAY': return '日班唯讀';
      case 'VIEWER_NIGHT': return '夜班唯讀';
      default: return 'Unknown Role';
    }
  }
  getCompanyName(code)
  {
    for (let c of window.DATA.company) {
      if (c.cd == code) return c.name;
    }
    return code;
  }
  getDistrictName(code)
  {
    for (let d of window.DATA.district) {
      if (d.cd == code) return d.name;
    }
    return code;
  }

  loadDictLoc()
  {
    if (null == dictLoc) {
      dictLoc = new Map();
      window.DATA.location.forEach(x => {
        x.cd = `${x.srv_dis}${x.srv_loc}`;
        x.name = `${x.name_zh} ${x.name_en}`.trim();
        dictLoc.set(`${x.srv_dis}${x.srv_loc}`, x);
      });
    }
    return dictLoc;
  }
  getLocation(loc)
  {
    this.loadDictLoc();
    if ('string' === typeof loc) return dictLoc.get(loc);
    else return dictLoc.get(`${loc.srv_dis}${loc.srv_loc}`);
  }
  getLocationName(loc)
  {
    this.loadDictLoc();
    let x = ('string' === typeof loc)
      ? dictLoc.get(loc)
      : dictLoc.get(`${loc.srv_dis}${loc.srv_loc}`);
    return x?.name;
  }

  getContactType(type)
  {
    switch(type)
    {
      case  1: return '賬單WhatsApp';
      case  4: return '賬單Fax';
      case  2: return '賬單電郵';
      case  3: return '寄單地址';
      case 10: return '電話';
      case 11: return '手機';
      case 12: return '傳真';
      case 13: return '電郵';
      case 20: return '地址';
      default: return '未知';
    }
  }

  getPaymentType(type)
  {
    type = String(type).toUpperCase();
    let text = {
      0: '未付款',
      C: '現金',   T: '轉賬',  Q: '支票',
      P: 'PayMe', F: '轉數快',
      A: '調整',   X: '壞賬',  Z: '賠償',
    }[type]||'未定義';
    let color = {
      0: 'red'
    }[type]||'inherit';
    return <span className="pay-status" style={{color}}>{ text }</span>;
  }

  getOrderStatus(status)
  {
    switch (status)
    {
      case  0: return '新訂單';
      case  1: return '已取消';
      case  2: return '已拒絕';
      case  8: return '暫緩';
      case  9: return '待跟進';
      case 10: return '處理中';
      case 11: return '送遞中';
      case 12: return '已送遞';
      default: return 'Unknown';
    }
  }

  getLeaveType(type)
  {
    return [0,'年假','事假','病假','無薪假','補假/恩恤假',
     '婚假','產假','侍產假','育嬰假',
     '喪假','陪審團','離修假','公司福利','其他'
    ][type] || 'Unknown';
  }

  getInvoiceTypeName(type)
  {
    return {
      'invoice':      '賬單',
      'receipt':      '收據',
      'acm_price_up': '加價通告'
    }[type] || 'Unknown';
  }

  nf(n) {
    n = parseFloat(n);
    return isNaN(n) ? '-'
      : parseFloat(n).toLocaleString('en-HK');
  }
  nf2(n) {
    n = parseFloat(n);
    return isNaN(n) ? '-'
      : n.toLocaleString('en-HK', {
        minimumFractionDigits: 2, maximumFractionDigits: 2
      });
  }
  LPAD(s, n) {
    let t = '0'.repeat(n)+String(s);
    return t.substring(t.length-n);
  }

  default(v, d)
  {
    if (null === v || 'undefined' === typeof(v)) return d;
    return v;
  }

  trimDate(d)  {
    if (!d) return '';
    d = new Date(moment(d).valueOf());
    d.setHours(0,0,0,0);
    return moment(d);
  }

  WeekdayName(i) {
    return ['','一','二','三','四','五','六','日'][i]||'';
  }

  ShortDate(d) { return d?moment(d).format(C_DTM_SHORT):''; }
  LongDate(d)  { return d?moment(d).format(C_DTM_LONG):'';  }
  FullDate(d)  { return d?moment(d).format(C_DTM_FULL):'';  }
  DSTR(d,e)    { return d?moment(d).format(C_DTM_DATA):e||Util.getToday(); }
  YearMonth(d) {
    d = moment(d);
    if (!d.isValid()) return '';
    let year  = d.get('year');
    let month = ['一','二','三','四','五','六','七','八','九','十','十一','十二'][d.get('month')]||'?';
    return `${year}年 ${month}月`;
  }

  getToday() { return moment().startOf('day').toDate(); }

  getReasonType(id)
  {
    switch (id)
    {
      case 0: return '其他';
      case 1: return '無抹/服務差';
      case 5: return '搬屋';
      case 2: return '不用車/離港/移民';
      case 3: return '撞車/劏車';
      case 4: return '欠款/公司停';
      default: return '不明';
      }
  }

  sortLocationID(a,b)
  {
    if (a[0] > b[0]) return  1;
    if (a[0] < b[0]) return -1;
    let [aid, bid] = [a, b].map(x => parseInt(x.slice(1), 10));
    if (aid > bid) return  1;
    if (aid < bid) return -1;
    return 0;
  }

  sortLocationObject(a,b)
  {
    if (null == a && null == b) return  0;
    if (null == a && null != b) return -1;
    if (null != a && null == b) return  1;
    if (a.dis > b.dis) return  1;
    if (a.dis < b.dis) return -1;
    if (a.mgt > b.mgt) return  1;
    if (a.mgt < b.mgt) return -1;
    if (a.loc > b.loc) return  1;
    if (a.loc < b.loc) return -1;
    return 0;
  }

  download(resp, filename)
  {
    if (resp.status >= 300)
    {
      PopMessage.show('伺服器錯誤，請聯絡系統管理員。', '錯誤', 'danger');
    } else if (!resp.blob) {
      PopMessage.show('下載失敗。', '錯誤', 'danger');
    } else {
      resp.blob().then(b => {
        let file = window.URL.createObjectURL(b);
        this.downloadFromObjectUrl(file, filename);
      });
    }
  }

  downloadFromObjectUrl(url, filename)
  {
    let a = document.createElement('a');
    a.setAttribute('href', url);
    a.setAttribute('download', filename);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

}
class DataImpl
{
  get defaultWorkerId() { return window.DATA.defaultWorkerId; }
  get company()         { return window.DATA.company;         }
  get district()        { return window.DATA.district;        }
  get location()        { return window.DATA.location;        }
  get plan()            { return window.DATA.plan;            }
  get vtype()           { return window.DATA.vtype;           }
  get license()         { return window.DATA.license;         }
  get brand()           { return window.DATA.brand;           }
  get price()           { return window.DATA.price;           }
  get wkrloc()          { return window.DATA.wkrloc;          }
  get serviceGroup()    { return window.DATA.serviceGroup;    }
}

const Util = new Utility();
export default Util;
export const Data = new DataImpl();

export function printContent(content, {css, callback, delay, debug} = {})
{
  // create print document
  let frame = document.createElement('iframe');
  if (!debug)
  {
    // bug fix for Chrome v108
    frame.style.position = 'fixed';
    frame.style.top      = 0;
    frame.style.zIndex   = -1;
    // ---
    // frame.style.visibility = 'hidden';
    frame.style.height = 0;
  }

  document.body.appendChild(frame);
  let doc = frame.contentDocument;
  let wnd = frame.contentWindow;

  // setup removal
  if (!debug)
  {
    wnd.addEventListener('afterprint', () => {
      document.body.removeChild(frame);
    }, { once: true });
  }

  // for eliminating React warning
  let div = doc.createElement('div');
  doc.body.appendChild(div);

  // render print content by React
  let pRender = new Promise((resolve, reject) => {
    ReactDOM.render(content, div, resolve);
  });

  // set print style
  css = css||[];
  let prmLinks = [
    // import font
    'https://fonts.googleapis.com/earlyaccess/cwtexkai.css'
    // import custom style
    ,...css.map(x => `${window.location.protocol}//${window.location.hostname}:${window.location.port}/assets/css/${x}`)
  ].map(link => {
    let elm = doc.createElement('link');
    elm.setAttribute('type', 'text/css');
    elm.setAttribute('rel', 'stylesheet');
    elm.setAttribute('media', 'print');
    elm.setAttribute('href', link);
    doc.head.appendChild(elm);
    return elm;
  }).map(elm => new Promise((resolve, reject) => {
    // await for CSS loading
    elm.addEventListener('load', resolve);
  }));

  // append render to promise list
  prmLinks.push(pRender);

  /* function callback after render */
  Promise.all(prmLinks).then(() => {
    callback?.(div);
    setTimeout(() => {
      wnd.focus();
      if (debug) {
        frame.style.display          = 'block';
        frame.style.position         = 'fixed';
        frame.style.top              = '0';
        frame.style.left             = '0';
        frame.style.backgroundColor  = 'white';
        frame.style.zIndex           = 9999999999;
        frame.style.width            = '210mm';
        frame.style.height           = '297mm';
      } else {
        requestAnimationFrame(() => wnd.print());
      }
    }, delay);
  });
}

export function mergeTypedArrays(list)
{
  // remove null values
  list = list.filter(x => !!x && x.length > 0);

  // skip if no merge is required
  if (list.length < 2) { return list[0]; }

  // make sure that the typed arrays are of the same type
  let types = list.reduce((r,x) => r.add(x.constructor.name), new Set());
  if (1 != types.size)
    throw new Error(`The types of the arguments do not match: ${[...types].join(',')}`);

  // start merging
  let N = list.reduce((r,x) => r + x.length, 0);
  var C = new list[0].constructor(N);

  let cursor = 0;
  list.forEach(x => {
    C.set(x, cursor);
    cursor += x.length;
  })

  return C;
}

// polyfill
window.btoa = (data) =>
{
  if (data.constructor.name === 'String')
  {
    let encoder = new TextEncoder('utf8')
    data = encoder.encode(data)
  }

  function mapB64(bit6)
  {
    if (bit6 < 26) {
      return String.fromCharCode(bit6+65);
    } else if (bit6 < 52) {
      return String.fromCharCode(bit6+71);
    } else if (bit6 < 62) {
      return String.fromCharCode(bit6-4);
    } else switch(bit6) {
      case 62: return '+';
      case 63: return '/';
    }
  }

  let output = '';

  const N = data.length;
  for (let i = 0; i < N; i += 3)
  {
    let [b1, b2, b3] = [data[i], data[i+1]||0, data[i+2]||0];
    let q1 = b1 >> 2;
    let q2 = (b1 & 0b000011) << 4 | (b2 >> 4);

    output += mapB64(q1)
    output += mapB64(q2)

    if (i+1 >= data.length) {
      output += '==';
      return output
    } else {
      let q3 = (b2 & 0b001111) << 2 | (b3 >> 6);
      output += mapB64(q3);
    }

    if (i+2 >= data.length)
    {
      output += '=';
      return output;
    } else {
      let q4 = (b3 & 0b111111);
      output += mapB64(q4);
    }
  }
  return output;
}